import { Component, computed, input, Signal } from "@angular/core";
import { NgxSpinnerComponent, Size } from "ngx-spinner";
import { NgClass } from "@angular/common";

@Component({
  selector: "common-overlay-spinner",
  standalone: true,
  imports: [NgxSpinnerComponent, NgClass],
  templateUrl: "./overlay-spinner.component.html",
  styleUrl: "./overlay-spinner.component.scss",
})
export class OverlaySpinnerComponent {
  /**
   * Optional loading text label
   */
  readonly text = input("");
  /**
   * Optional spinner name.
   * If no name will be provided. Use the show and hide methods without name parameter to reference this spinner.
   * If name will be provided. Use the show and hide methods with the exact name parameter to reference the spinner.
   */
  readonly spinnerName = input("primary");
  /**
   * Optional is full screen flag. (true by default)
   * If true will overlay the whole screen.
   * If false it will overlay the parent container. (The parent position needs to be relative).
   */
  readonly isFullScreen = input(true);
  readonly spinnerSize: Signal<Size> = computed(() => {
    if (this.isFullScreen()) {
      return "medium";
    } else {
      return "default";
    }
  });
  readonly textSizeClass: Signal<string> = computed(() => {
    if (this.isFullScreen()) {
      return "spinner-text-medium";
    } else {
      return "spinner-text-default";
    }
  });
}
